export default function Step2() {
    return (
        <svg width="53" height="52" viewBox="0 0 53 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M39.8089 8.66602H12.846C10.7187 8.66602 8.99414 10.3905 8.99414 12.5179V39.4808C8.99414 41.6081 10.7187 43.3327 12.846 43.3327H39.8089C41.9363 43.3327 43.6608 41.6081 43.6608 39.4808V12.5179C43.6608 10.3905 41.9363 8.66602 39.8089 8.66602Z"
                stroke="#7293F7"
                strokeWidth="2.5"
            />
            <path
                d="M26.3265 26.9626C28.9857 26.9626 31.1413 24.807 31.1413 22.1478C31.1413 19.4887 28.9857 17.333 26.3265 17.333C23.6674 17.333 21.5117 19.4887 21.5117 22.1478C21.5117 24.807 23.6674 26.9626 26.3265 26.9626Z"
                stroke="#7293F7"
                strokeWidth="2.5"
            />
            <path
                d="M34.9945 36.5915C34.9945 31.805 31.1143 27.9248 26.3278 27.9248C21.5413 27.9248 17.6611 31.805 17.6611 36.5915"
                stroke="#7293F7"
                strokeWidth="2.5"
                strokeLinecap="round"
            />
        </svg>
    );
}
